// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"60a6700b","778":"14a7fd4f"}[chunkId] + ".chunk.css";
};